module.exports = __webpack_public_path__ + "img/gold11.00d7d24d.gif";